import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import FruitDetail from "@/pages/FruitDetail";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/catalogo" element={<Catalog />} />
        {/* Compatibilità con i collegamenti precedenti */}
        <Route path="/frutti-del-diavolo" element={<Catalog />} />
        <Route path="/frutto/:slug" element={<FruitDetail />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
